// eslint-disable-next-line import/prefer-default-export
export const SIDEBAR_WIDTH = 248;
